import React from "react";
import { SvgProps } from ".";

export const LogoutSvg: React.FC<SvgProps> = ({ fill }) => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-labelledby="Logout"
    >
      <title id="Logout">Logout</title>
      <g
        id="Logout"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        opacity="0.5"
      >
        <g
          id="Simplified---Expanded-Nav---LG"
          transform="translate(-1125.000000, -284.000000)"
        >
          <g
            id="Account-dropdown"
            transform="translate(1110.000000, 78.000000)"
          >
            <g id="Group" transform="translate(15.000000, 206.000000)">
              <rect id="Rectangle" x="0" y="0" width="30" height="30" />
              <polyline
                id="Path"
                stroke={fill || "#1853A3"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="20.3919141 10.078125 25.3125 15 20.3919141 19.921875"
              />
              <line
                x1="12.1875"
                y1="15"
                x2="25.3090512"
                y2="15"
                id="Path"
                stroke={fill || "#1853A3"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.1875,25.3125 L5.625,25.3125 C5.10723305,25.3125 4.6875,24.892767 4.6875,24.375 L4.6875,5.625 C4.6875,5.10723305 5.10723305,4.6875 5.625,4.6875 L12.1875,4.6875"
                id="Path"
                stroke={fill || "#1853A3"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default {};
